import { render, staticRenderFns } from "./companyQualification.vue?vue&type=template&id=1c1f1820&scoped=true&"
import script from "./companyQualification.vue?vue&type=script&lang=js&"
export * from "./companyQualification.vue?vue&type=script&lang=js&"
import style0 from "./companyQualification.vue?vue&type=style&index=0&id=1c1f1820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1f1820",
  null
  
)

export default component.exports